import { z } from 'zod';

/** Нода ещё готовит анимацию — полей событие не несёт. */
export interface PersonWaitingInfoEvent {
  readonly type: 'info';
}

/** Анимация готова. */
export interface PersonWaitingCompleteEvent {
  readonly type: 'complete';
}

/**
 * Нода сообщила об ошибке. Полей событие не несёт, поэтому текст ноды
 * пишется в диагностику на месте разбора — иначе AVA-UNKNOWN не разобрать.
 */
export interface PersonWaitingErrorEvent {
  readonly type: 'error';
}

/**
 * Объединение по ключу `type` — `@Freezed(unionKey: 'type')` в Dart.
 * Потребитель разбирает его обычным `switch (event.type)`.
 */
export type PersonWaitingEvent =
  | PersonWaitingInfoEvent
  | PersonWaitingCompleteEvent
  | PersonWaitingErrorEvent;

/** `const PersonWaitingEvent.info()` — значение единственное, полей нет. */
export const personWaitingInfoEvent: PersonWaitingInfoEvent = { type: 'info' };

/** `const PersonWaitingEvent.complete()`. */
export const personWaitingCompleteEvent: PersonWaitingCompleteEvent = {
  type: 'complete',
};

/** `const PersonWaitingEvent.error()`. */
export const personWaitingErrorEvent: PersonWaitingErrorEvent = {
  type: 'error',
};

/** Переименований нет — только разбор ключа `type`. */
export const personWaitingEventSchema = z.discriminatedUnion('type', [
  z.object({ type: z.literal('info') }),
  z.object({ type: z.literal('complete') }),
  z.object({ type: z.literal('error') }),
]);

export function personWaitingEventFromJson(json: unknown): PersonWaitingEvent {
  return personWaitingEventSchema.parse(json);
}

/**
 * `PersonWaitingEvent.tryParse` — чужой `type` или не-объект дают `null`,
 * такое событие SSE-потока просто пропускается.
 */
export function personWaitingEventTryParse(
  json: unknown,
): PersonWaitingEvent | null {
  const result = personWaitingEventSchema.safeParse(json);
  return result.success ? result.data : null;
}

export function personWaitingEventToJson(
  event: PersonWaitingEvent,
): Record<string, unknown> {
  return {
    type: event.type,
  };
}
